import {SingletonService} from '@/common/dependency.configs.ts'
import {inject, injectable} from 'inversify'
import HttpHandler from '@/common/services/connect/HttpHandler.ts'
import type RestResponse from '@/common/data/RestResponse.ts'

@SingletonService
@injectable()
export class BranchTrackerFactory {
  constructor(@inject(HttpHandler) private httpHandler: HttpHandler) {}

  get(workspaceUUID: string): Promise<RestResponse<BranchTracker>> {
    return this.httpHandler.get(`{{boltsbranch}}/workspace/${workspaceUUID}/branch-tracker`)
  }

  save(dto: BranchTracker): Promise<RestResponse<BranchTracker>> {
    return this.httpHandler.post(`{{boltsbranch}}/workspace/${dto.workspaceUuid}/branch-tracker`, dto)
  }
}

export interface BranchTracker {
  workspaceUuid: string,
  workflowGroupId: string
}